import script from "./IcpComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./IcpComp.vue?vue&type=script&setup=true&lang=ts"

import "./IcpComp.vue?vue&type=style&index=0&id=1626c436&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/jenkins_home/workspace/QuickApp_NapH5_YQZK_YiZhiAiChong/yzac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1626c436"]])

export default __exports__